<template>
  <!-- 语调选择 -->
  <SelectPopper v-bind="$attrs" v-on="$listeners" :value="value" :options="pitchArr" />
</template>
<script>
import SelectPopper from "../select-popper/select-popper.vue"
export default {
  components: {
    SelectPopper
  },
  props: {
    value: {
      type: String,
      default: '0'
    }
  },
  created() {
    this.pitchArr = [
      "-10",
      "-9",
      "-8",
      "-7",
      "-6",
      "-5",
      "-4",
      "-3",
      "-2",
      "-1",
      "0",
      "+1",
      "+2",
      "+3",
      "+4",
      "+5",
      "+6",
      "+7",
      "+8",
      "+9",
      "+10",
    ]
  },
  methods: {

  }
}
</script>